// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsettingsFullTab
{
    width: 100%;
    height: 98%;

    color: white;
}

.tabsettingsTitleTab
{
    padding-top: 10px;
    width: 100%;
    height: 28px;
    color: white;
    text-align: center;
    font-size: medium;
    font-family: Arial, Helvetica, sans-serif;

    
}
.tabsettingscontentdata
{
    position: relative;
    width: 100%;
    height: calc(100% - 32px);
    
    
}
.tabsettingscontentdataScrollable
{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  

}




.tabsettingscontentdataScrollable::-webkit-scrollbar-track {
  background: #101010; /* color of the tracking area */
}

.tabsettingscontentdataScrollable::-webkit-scrollbar-thumb {
  background-color: #151515; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
}

.tabsettingscontentdataScrollable::-webkit-scrollbar{
  width:6px;
}


.tabsettingslidertext
{
  font-size: small;
  text-align: left;
}


.tabsettingtitle
{
  font-size: small;
  width: calc(100% - 10px);
  text-align: center;
  background-color: #303030;
  border-color: #808080;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tabsettingscomboboxtext
{
  background-color: black;
  color: white;
  border-color: var(--default-icon-color);
  border-radius: 6px;
  padding: 5px 5px;
}
.tabsettingscomboboxtext:focus {
  border-color: var(--default-icon-color);
  outline: none;
}
.sliderSettings {
    appearance: none;
    height: var(--timeline-bottom-height);
    width: 97%;
  }
  
 .sliderSettings:focus {
    outline: none;
  }

  .sliderSettings::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  
  .sliderSettings:disabled::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }


  .sliderSettings:focus::-webkit-slider-runnable-track {
    background: var(--default-icon-color);
  }
  
  .sliderSettings::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  

  .sliderSettings:disabled::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  
  .sliderSettings:disabled::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }

  .sliderSettings::-ms-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  
  .sliderSettings::-ms-fill-lower {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }

  .sliderSettings::-ms-fill-upper {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  
  .sliderSettings::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }

  .sliderSettings::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }
  
  .sliderSettings::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: calc(var(--timeline-bottom-height)/(-3));
    
  }


  .sliderSettings:disabled::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-disable-icon-color);
    cursor: pointer;
  }



`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appsettings/tabs/tabs.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,WAAW;;IAEX,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;;;AAG7C;AACA;;IAEI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;;;AAG7B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;;;AAGpB;;;;;AAKA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,wCAAwC;AACvF;;AAEA;EACE,SAAS;AACX;;;AAGA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;IAEI,gBAAgB;IAChB,qCAAqC;IACrC,UAAU;EACZ;;CAED;IACG,aAAa;EACf;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,wBAAwB;IACxB,oDAAoD;;EAEtD;;;EAGA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;EACjB","sourcesContent":[".tabsettingsFullTab\n{\n    width: 100%;\n    height: 98%;\n\n    color: white;\n}\n\n.tabsettingsTitleTab\n{\n    padding-top: 10px;\n    width: 100%;\n    height: 28px;\n    color: white;\n    text-align: center;\n    font-size: medium;\n    font-family: Arial, Helvetica, sans-serif;\n\n    \n}\n.tabsettingscontentdata\n{\n    position: relative;\n    width: 100%;\n    height: calc(100% - 32px);\n    \n    \n}\n.tabsettingscontentdataScrollable\n{\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  \n\n}\n\n\n\n\n.tabsettingscontentdataScrollable::-webkit-scrollbar-track {\n  background: #101010; /* color of the tracking area */\n}\n\n.tabsettingscontentdataScrollable::-webkit-scrollbar-thumb {\n  background-color: #151515; /* color of the scroll thumb */\n  border-radius: 20px; /* roundness of the scroll thumb */\n  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n}\n\n.tabsettingscontentdataScrollable::-webkit-scrollbar{\n  width:6px;\n}\n\n\n.tabsettingslidertext\n{\n  font-size: small;\n  text-align: left;\n}\n\n\n.tabsettingtitle\n{\n  font-size: small;\n  width: calc(100% - 10px);\n  text-align: center;\n  background-color: #303030;\n  border-color: #808080;\n  border-radius: 5px;\n  border-width: 1px;\n  border-style: solid;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.tabsettingscomboboxtext\n{\n  background-color: black;\n  color: white;\n  border-color: var(--default-icon-color);\n  border-radius: 6px;\n  padding: 5px 5px;\n}\n.tabsettingscomboboxtext:focus {\n  border-color: var(--default-icon-color);\n  outline: none;\n}\n.sliderSettings {\n    -webkit-appearance: none;\n    appearance: none;\n    height: var(--timeline-bottom-height);\n    width: 97%;\n  }\n  \n .sliderSettings:focus {\n    outline: none;\n  }\n\n  .sliderSettings::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n  .sliderSettings:disabled::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n\n\n  .sliderSettings:focus::-webkit-slider-runnable-track {\n    background: var(--default-icon-color);\n  }\n  \n  .sliderSettings::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n  .sliderSettings:disabled::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n  .sliderSettings:disabled::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n\n  .sliderSettings::-ms-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    border-width: 16px 0;\n    color: transparent;\n  }\n  \n  .sliderSettings::-ms-fill-lower {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n\n  .sliderSettings::-ms-fill-upper {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n  \n  .sliderSettings::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n\n  .sliderSettings::-moz-range-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n  \n  .sliderSettings::-webkit-slider-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: calc(var(--timeline-bottom-height)/(-3));\n    \n  }\n\n\n  .sliderSettings:disabled::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-disable-icon-color);\n    cursor: pointer;\n  }\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
